<template>
  <DxDataGrid
    v-bind="commonProps.dataGrid"
    :data-source="complaints"
    :columns="columns"
    :on-cell-prepared="onCellPrepared"
  />
</template>

<script>
import {
  DxDataGrid,
} from 'devextreme-vue/data-grid';
import { mapActions, mapState } from 'vuex';
import { commonProps } from '../trips/tripsColumnData';
import columns, { colMethods } from './complaintsTableColumnData';

export default {
  name: 'ComplaintsTable',
  components: {
    DxDataGrid,
  },
  data() {
    return {
      commonProps,
      columns,
    };
  },
  computed: {
    ...mapState('Complaints', ['complaints']),
  },
  async beforeMount() {
    await this.fetchComplaints();
  },
  methods: {
    onCellPrepared(row) {
      if (row.column.type === 'buttons') this.addButtonFuncs(row.column.buttons);
    },
    ...colMethods,
    ...mapActions('Complaints', ['fetchComplaints', 'removeMerchandise']),
  },

};
</script>

<style>

</style>
